import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import CardUpdate from '../../Global/CardUpdate/CardUpdate';
import Section from '../../Global/Section/Section';
import { isArray } from '../../../utils';

const LatestUpdates = ({ block, items = [], variant }) => {
  const { title, linkToAll } = block;
  const latestsPosts = useStaticQuery(graphql`
    query LatestPosts {
      allDatoCmsPost(limit: 3, sort: { date: DESC }) {
        edges {
          node {
            ...PostCard
          }
        }
      }
    }
  `);

  const itemsSorted = [...latestsPosts.allDatoCmsPost.edges];

  const customItems = Array.isArray(items) && items.length > 0;
  const finalItems = customItems ? items : itemsSorted;
  const linkAll = linkToAll ? linkToAll[0] : null;

  return (
    <>
      {isArray(finalItems) && (
        <Section title={title} link={linkAll} extraClassNames="gy-4 gy-xl-0">
          {finalItems.map((post) => (
            <div
              key={post.node.id}
              className={`${customItems ? 'col-xl-6 col-lg-12 col-sm-12' : 'col-xl-4 col-lg-6 col-md-6 col-sm-12'}`}
            >
              <CardUpdate post={post.node} variant={variant} />
            </div>
          ))}
        </Section>
      )}
    </>
  );
};

export default LatestUpdates;
